module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "sigilnotintoc1",
    attrs: {
      "id": "pgepubid00005"
    }
  }, [_vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('table', {
    staticClass: "calibre7",
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0",
      "summary": "List of Illustrations",
      "width": "75%"
    }
  }, [_c('tbody', {
    staticClass: "calibre8"
  }, [_c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tdlsc"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/Section0004.htm#imagepxliv"
    }
  }, [_vm._v("Interior of a Submarine")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr1"
  }, [_vm._v("xliv")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tdlsc"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/Section0007.htm#imagep036"
    }
  }, [_vm._v("A Torpedoed Schooner")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr1"
  }, [_vm._v("36")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tdlsc"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/Section0008.htm#imagep040"
    }
  }, [_vm._v("German Submarines U 13, U 5, U 11, U 3, and U 16 in Kiel Harbor")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr1"
  }, [_vm._v("40")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tdl"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/Section0010.htm#imagep078"
    }
  }, [_c('span', {
    staticClass: "sc1"
  }, [_vm._v("Von Forstner's Submarine (U 28) in Action in the North Sea: A Series of Photographs taken from the Deck of one of her Victims")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "c"
  }, [_vm._v("From the London "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Graphic")]), _vm._v(", March 27, 1915")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr1"
  }, [_vm._v("78")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tdlsc"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/Section0011.htm#imagep098"
    }
  }, [_vm._v("Lifeboat leaving the Sinking P. and O. Liner Arabia")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr1"
  }, [_vm._v("98")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tdlsc"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/Section0012.htm#imagep126"
    }
  }, [_vm._v("British Hospital Ship Gloucester Castle, showing Red Cross on Bow, sunk in the English Channel by a German Submarine")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr1"
  }, [_vm._v("126")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0